module.exports = __webpack_public_path__ + "static/media/ENVIRONMENT - Warm grey 3C.8285756c.jpg";